import { Module } from "@/constants";
import { getDictionaryConfig } from "@/containers/dictionaries/getDictionaryConfig";
import {
  ReadShiftReportDepartment,
  WriteShiftReportDepartment,
} from "@/types/shiftReportDepartment";

export const useShiftReportDepartmentsDictionary = () => {
  const config = getDictionaryConfig<
    ReadShiftReportDepartment,
    WriteShiftReportDepartment
  >(Module.ShiftReportDepartments);
  return config;
};
